module.exports = __webpack_public_path__ + "media/images/OrlandoHD-9e1547e0.jpg";